// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__NLK2K","logo":"styles_logo__sGBNE","section":"styles_section__2qD89"};